module.exports = __webpack_public_path__ + "img/cube.f61d4ee9.png";